<template>
  <div class="results" :class="{'has-panel': fightCategories && formsCategories}">

    <div class="loading" v-if="selectedEvent && selectedCategoryId && !results"></div>

    <div class="categories-nav" :class="{hidden: fightResults || formsResults}" v-if="fightCategories && formsCategories && selectedEvent">
      <div class="categories-nav-title" @click="reset">
        <div class="categories-nav-title-back"></div>
        <div class="categories-nav-title-caption">{{selectedEvent.title}}</div>        
      </div>
      <div class="categories-nav-divisions">
        <div class="categories-nav-division" @click="selectedDivision = 'fight'" :class="{active: selectedDivision === 'fight'}">{{$t('message.fight')}}</div>
        <div class="categories-nav-division" @click="selectedDivision = 'forms'" :class="{active: selectedDivision === 'forms'}">{{$t('message.forms')}}</div>
      </div>
      <div class="categories-nav-filters">
        <div class="categories-nav-filters-clear" @click="clearFilters" v-if="showFilters">{{$t('message.clearFilters')}}</div>
        <div class="categories-nav-filters-show" @click="showFilters = !showFilters"></div>
        <div class="categories-nav-filters-columns" v-if="showFilters">
          <div class="categories-nav-filters-column">
            <div class="categories-nav-filter">
              <input type="checkbox" id="kids" value="kids" v-model="ageFilters">
              <label for="kids">Kids (-12)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="juniors" value="juniors" v-model="ageFilters">
              <label for="juniors">Juniors (13-14)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="teens" value="teens" v-model="ageFilters">
              <label for="teens">Teens (15-17)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="adults" value="adults" v-model="ageFilters">
              <label for="adults">Adults (18+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="veterans" value="veterans (+35)" v-model="ageFilters">
              <label for="veterans">Veterans (35+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="executives" value="executives (+45)" v-model="ageFilters">
              <label for="executives">Executives (45+)</label>
            </div>
            <div class="categories-nav-filter">
              <input type="checkbox" id="seniors" value="seniors (+55)" v-model="ageFilters">
              <label for="seniors">Seniors (55+)</label>
            </div>
          </div>

          <div class="categories-nav-filters-column" v-if="selectedDivision === 'fight'">
            <div class="categories-nav-filter">
              <input type="checkbox" id="pointfighting" value="pointfighting" v-model="fightFilters">
              <label for="pointfighting">Point Fighting</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="kumite" value="karate kumite" v-model="fightFilters">
              <label for="kumite">Karate Kumite</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="lightcontact" value="light contact" v-model="fightFilters">
              <label for="lightcontact">Light Contact</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="kicklight" value="kick light" v-model="fightFilters">
              <label for="kicklight">Kick Light</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="fullcontact" value="full contact" v-model="fightFilters">
              <label for="fullcontact">Full Contact</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="k1" value="k1" v-model="fightFilters">
              <label for="k1">K1</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="neopro" value="neopro" v-model="fightFilters">
              <label for="neopro">NeoPro Boxing</label>
            </div>          
            <!--div class="categories-nav-filter">
              <input type="checkbox" id="thaiboxing" value="thai boxing" v-model="fightFilters">
              <label for="thaiboxing">Thai Boxing</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="mma" value="mma" v-model="fightFilters">
              <label for="mma">MMA</label>
            </div-->          
          </div>

          <div class="categories-nav-filters-column" v-if="selectedDivision === 'forms'">
            <div class="categories-nav-filter">
              <input type="checkbox" id="freestyle" value="freestyle" v-model="formsFilters">
              <label for="freestyle">Freestyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="hardstyle" value="hardstyle" v-model="formsFilters">
              <label for="hardstyle">Hardstyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="itf" value="itf" v-model="formsFilters">
              <label for="itf">ITF Style</label>
            </div>                 
            <div class="categories-nav-filter">
              <input type="checkbox" id="karatetraditional" value="karate traditional" v-model="formsFilters">
              <label for="karatetraditional">Karate Traditional</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="karateweapons" value="karate weapons" v-model="formsFilters">
              <label for="karateweapons">Karate Weapons</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="korean" value="korean" v-model="formsFilters">
              <label for="korean">Korean Style</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="softstyle" value="softstyle" v-model="formsFilters">
              <label for="softstyle">Softstyle</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="traditionalstyle" value="traditional style" v-model="formsFilters">
              <label for="traditionalstyle">Traditional Style</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="weapons" value="weapons without music" v-model="formsFilters">
              <label for="weapons">Weapons</label>
            </div>          
            <div class="categories-nav-filter">
              <input type="checkbox" id="weaponsmusic" value="weapons with music" v-model="formsFilters">
              <label for="weaponsmusic">Weapons with Music</label>
            </div>          
          </div>
          
        </div>
      </div>

      <div class="categories-nav-content fight" v-show="selectedDivision === 'fight'" @scroll="saveScrollFight($event)">
        <div class="categories-nav-item" v-for="item in filteredFightCategories" v-show="item.competitorCount > 0" :key="item.id" @click="getFightResults(item.id)" :class="[{active: selectedCategoryId === item.id}, {empty: item.competitorCount === 0}]">
          <div class="categories-nav-item-code">{{item.bez_short}}</div>
          <div class="categories-nav-item-title">{{item.cat_name}} {{item.bez}} {{item.gender}} {{item.vz}}{{item.val}}{{item.unity}}</div>
          <div class="categories-nav-item-additionals">
            <div class="categories-nav-item-additionals-count" v-if="item.competitorCount > 0">{{item.competitorCount}}</div>
          </div>
        </div>
      </div>
      <div class="categories-nav-content forms" v-show="selectedDivision === 'forms'" @scroll="saveScrollForms($event)">
        <div class="categories-nav-item" v-for="item in filteredFormsCategories" v-show="item.competitorCount > 0" :key="item.id" @click="getFormsResults(item.id)" :class="[{active: selectedCategoryId === item.id}, {empty: item.competitorCount === 0}]">
          <div class="categories-nav-item-code">{{item.bez_short}}</div>
          <div class="categories-nav-item-title">{{item.cat_name}} {{item.bez}} {{item.gender}}</div>
          <div class="categories-nav-item-additionals">
            <div class="categories-nav-item-additionals-count" v-if="item.competitorCount > 0">{{item.competitorCount}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- SEASONS -->
    <div class="container" v-if="!selectedEvent && seasons">
      <!-- REGISTRATIONS -->
      <div v-if="registrationEvents">
        <h1 class="headline" v-if="registrationEvents.length > 0">{{$t('message.registrationsAvailable')}}</h1>
        <div class="list-item" v-for="item in registrationEvents" @click="selectedEvent = item" :key="item.id">
          <div class="list-item-image">
            <div class="list-item-image-icon-world" v-if="item.type_id === '1'"></div>
            <div class="list-item-image-typo" v-if="item.type_id > 1">{{item.type_title_short}}</div>
          </div>
          <div class="list-item-caption">
            <div class="list-item-title">{{item.title}}</div>
            <div class="list-item-subtitle">{{item.startDate | moment('Do MMMM YYYY')}}</div>
          </div>       
        </div>
      </div>

      <!-- EVENTS IN SEASONS -->
      <h1 class="headline">GCO {{$t('message.results')}}</h1>      
      <div v-if="seasons">
        <div class="list-group" v-for="season in seasons" :key="season.id">
          <div class="list-group-title center"><h2>{{season.season}}</h2></div>
          <div class="list-item" v-for="item in season.events" @click="selectedEvent = item" :key="item.id" v-show="item.show_competitor + item.show_result !== '10'" :class="{inactive: item.show_result === '0' && item.show_competitor === '0'}">
            <div class="list-item-image">
              <div class="list-item-image-icon-world" v-if="item.type_id === '1'"></div>
              <div class="list-item-image-typo" v-if="item.type_id > 1">{{item.type_title_short}}</div>
            </div>
            <div class="list-item-caption">
              <div class="list-item-title">{{item.title}}</div>
              <div class="list-item-subtitle">{{item.startDate | moment('Do MMMM YYYY')}}</div>
            </div>
            <div class="list-item-additionals">
              <div class="list-item-additional small-hint hide-mobile" v-if="item.show_result === '0' && item.show_competitor === '0'">{{$t('message.noDataAvailable')}}</div> 
            </div>         
          </div>
        </div>
      </div>
    </div>

    <!-- RESULTS -->
    <h2 class="headline" v-if="selectedEvent">{{selectedEvent.title}}</h2>
    <div class="container" v-if="results && selectedEvent">
      <h2 class="headline has-back"><div class="headline-back-btn" @click="resetCategory()"></div>{{results.category.cat_name}} {{results.category.bez}} {{results.category.gender}} {{results.category.vz}}{{results.category.val}}{{results.category.unity}}</h2>

      <div v-if="selectedEvent.show_result === '1' && results.result.length === 0">
        {{$t('message.noResultsInCategory')}}
      </div>
      <div class="results-medals" v-if="selectedEvent.show_result === '1' && results.result.length > 0">
        <h3>{{$t('message.results')}}</h3>
        <div class="list-item" v-for="item in results.result" :key="item.map" :id="'member' + item.map" @click="goMember(item)" :class="{inactive: item.organisation_id !== '1' && item.organisation_id !== '5'}">  
          <div class="list-item-image pure">
            <img :src="gfxPath +'medals_wcs_gold.png'" v-if="item.ranking === '1'"/>
            <img :src="gfxPath +'medals_wcs_silver.png'" v-if="item.ranking === '2'"/>
            <img :src="gfxPath +'medals_wcs_bronze.png'" v-if="item.ranking === '3'"/>
            <img :src="gfxPath +'medals_wcs_fourth.png'" v-if="item.ranking === '4'"/>
          </div>
          <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
          <div class="list-item-caption">
            <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
            <div class="list-item-subtitle">MAP {{item.map}} {{item.ranking}}</div>
          </div>
          <div class="list-item-additionals">
            <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            <div class="list-item-additional"><img class="list-flag" :src="flagsPath + item.flag"/></div>       
          </div>         
        </div>
        <br>
        <h3 v-if="participants.length > 0">{{$t('message.furtherParticipants')}}</h3>
        <div class="list-item" v-for="item in participants" :key="item.map" :id="'member' + item.map" @click="goMember(item)" :class="{inactive: item.organisation_id !== '1' && item.organisation_id !== '5'}">  
          <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
          <div class="list-item-caption">
            <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
            <div class="list-item-subtitle">MAP {{item.map}}</div>
          </div>
          <div class="list-item-additionals">
            <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            <div class="list-item-additional"><img class="list-flag" :src="flagsPath + item.flag"/></div>       
          </div>         
        </div> 
      </div>

      <div v-if="selectedEvent.show_result === '0'">
        <h3>{{results.competitors.length}} {{$t('message.registrationsSoFar')}}</h3>
        <div class="list-item" v-for="item in results.competitors" :key="item.map" :id="'member' + item.map" @click="goMember(item)" :class="{inactive: item.organisation_id !== '1' && item.organisation_id !== '5'}">  
          <div class="list-item-image"><img :src="item.memberImage" @error="onImageError"/></div>
          <div class="list-item-caption">
            <div class="list-item-title">{{item.firstname}} {{item.lastname}}</div>
            <div class="list-item-subtitle">MAP {{item.map}}</div>
          </div>
          <div class="list-item-additionals">
            <div class="list-item-additional hide-mobile"><img :src="logoPath + item.dojo_id + '.jpg'" @error="onLogoImageError"/></div>            
            <div class="list-item-additional"><img class="list-flag" :src="flagsPath + item.flag"/></div>       
          </div>         
        </div> 
      </div>

      <div class="pool-outer" v-if="pool && selectedEvent.show_pool === '1'">
        <pool :pool-data="pool"/>
      </div>

    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'belts',
  data () {
    return {
      selectedCategoryId: 0,
      selectedEvent: null,
      selectedDivision: 'fight',
      showFilters: true,
      fightCategoriesScrollTop: 0,
      formsCategoriesScrollTop: 0,
      ageFilters: ['kids', 'juniors', 'teens', 'adults', 'veterans (+35)', 'executives (+45)', 'seniors (+55)'],
      fightFilters: ['pointfighting', 'karate kumite', 'light contact', 'kick light', 'full contact', 'k1', 'neopro'], // hidden: , 'thai boxing', 'mma'
      formsFilters: ['freestyle', 'hardstyle', 'itf', 'karate traditional', 'karate weapons', 'korean', 'softstyle', 'traditional style', 'weapons without music', 'weapons with music']
    }
  },
  methods: {
    getFightCategories: function () {
      this.$store.dispatch('rankings/getEventFightCategories', this.selectedEvent.id).then(() => {
        this.getFormsCategories()
      })
    },
    getFormsCategories: function () {
      this.$store.dispatch('rankings/getEventFormsCategories', this.selectedEvent.id)
    },
    getSeasons: function () {
      this.$store.dispatch('events/getSeasons')
    },
    getFightResults: function (id) {
      this.saveScrollFight()
      this.selectedCategoryId = id
      this.$store.commit('rankings/SET_FIGHT_RESULTS', null)
      this.$store.commit('rankings/SET_FORMS_RESULTS', null)
      this.$store.dispatch('rankings/getFightResults',
        {
          catId: id,
          eventId: this.selectedEvent.id
        }).then(() => {
          this.restoreCategoriesScrollTop()
        })
    },
    getFormsResults: function (id) {
      this.saveScrollForms()
      this.selectedCategoryId = id
      this.$store.commit('rankings/SET_FIGHT_RESULTS', null)
      this.$store.commit('rankings/SET_FORMS_RESULTS', null)
      this.$store.dispatch('rankings/getFormsResults',
      {
        catId: id,
        eventId: this.selectedEvent.id
      }).then(() => {
        this.restoreCategoriesScrollTop()
      })
    },
    clearFilters: function () {
      this.ageFilters = []
      this.fightFilters = []
      this.formsFilters = []
    },
    reset: function () {
      this.selectedEvent = null
      this.selectedCategoryId = 0
      this.$store.commit('rankings/SET_FIGHT_CATEGORIES', null)
      this.$store.commit('rankings/SET_FORMS_CATEGORIES', null)
      this.$store.commit('rankings/SET_FIGHT_RESULTS', null)
      this.$store.commit('rankings/SET_FORMS_RESULTS', null)
    },
    resetCategory: function () {
      this.selectedCategoryId = 0
      this.$store.commit('rankings/SET_FIGHT_RESULTS', null)
      this.$store.commit('rankings/SET_FORMS_RESULTS', null)
    },
    goBelt: function (id, name) {
      // window.location.href = './#/belts/' + id + '/members'
      var breadcrumb = {
        name: name,
        route: '/belts/' + id + '/members'
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push({path: breadcrumb.route})
    },
    goMember: function (item) {
      var breadcrumb = {
        name: item.firstname + ' ' + item.lastname,
        route: '/member/' + item.map
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    },
    onLogoImageError: function (event) {
      event.target.src = './dojo-dummy.png'
    },
    onImageError: function (event) {
      event.target.src = './person-dummy.png'
    },
    isFuture: function (date) {
      return moment().diff(moment(date)) < 0
    },
    saveScrollFight: function () {
      this.fightCategoriesScrollTop = document.querySelector('.categories-nav-content.fight').scrollTop
    },
    saveScrollForms: function () {
      this.formsCategoriesScrollTop = document.querySelector('.categories-nav-content.forms').scrollTop
    },
    restoreCategoriesScrollTop: function () {
      var fightCats = document.querySelector('.categories-nav-content.fight')
      var formsCats = document.querySelector('.categories-nav-content.forms')
      if (fightCats)
        fightCats.scrollTop = this.fightCategoriesScrollTop
      if (formsCats)
        formsCats.scrollTop = this.formsCategoriesScrollTop
    }
  },
  computed: {
    filteredFightCategories: function () {
      return this.fightCategories.filter(category => 
        this.ageFilters.some(x => category.bez.toLowerCase().includes(x)) && this.fightFilters.some(x => category.cat_name.toLowerCase().includes(x)) && !category.cat_name.toLowerCase().includes('team')
      )
    },
    filteredFormsCategories: function () {
      return this.formsCategories.filter(category => 
        this.ageFilters.some(x => category.bez.toLowerCase().includes(x)) && this.formsFilters.some(x => category.cat_name.toLowerCase().includes(x)) && !category.cat_name.toLowerCase().includes('team')
      )
    },
    results: function () {
      if (this.fightResults) {
        return this.fightResults
      }
      if (this.formsResults) {
        return this.formsResults
      }
      return null
    },
    pool: function () {
      if (this.fightResults) {
        if (this.fightResults.drawing.length > 0) {
          return JSON.parse(this.fightResults.drawing[0].pool_json)
        }
      }
      return null
    },
    events: function () {
      var activeEvents = []
      if (this.fightRankings) {    
        if (this.fightRankings.category.ranking.length === 0) return null
        activeEvents = [...this.fightRankings.events]
        return activeEvents.splice(0, this.fightRankings.category.ranking[0].events.length)
      }
      if (this.formsRankings) {
        if (this.formsRankings.category.ranking.length === 0) return null
        activeEvents = [...this.formsRankings.events]
        return activeEvents.splice(0, this.formsRankings.category.ranking[0].events.length)
      }
      return null
    },
    ...mapGetters({
      seasons: 'events/seasons',
      registrationEvents: 'events/registrationEvents',
      fightCategories: 'rankings/eventFightCategories',
      formsCategories: 'rankings/eventFormsCategories',
      fightResults: 'rankings/fightResults',
      formsResults: 'rankings/formsResults',
      participants: 'rankings/participants',
      flagsPath: 'countries/flagsPath',
      beltsPath: 'members/beltsPath',
      logoPath: 'dojos/logoPath',
      gfxPath: 'members/gfxPath'
    })
  },
  watch: {
    selectedEvent: function (val) {
      if (val) {
        this.getFightCategories()
      }
    }
  },
  created: function () {
    this.selectedEvent = null
    this.selectedCategoryId = 0
    this.$store.commit('rankings/SET_FIGHT_RESULTS', null)
    this.$store.commit('rankings/SET_FORMS_RESULTS', null)
    this.getSeasons()
  }
}
</script>
